import { useMutation } from "@tanstack/react-query";
import { updateReviewStatus } from "../services/solevaniaService";
import { useNavigate } from "react-router-dom";

export const useUpdateReviewStatus = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (payload) => updateReviewStatus(payload),
    onSuccess: () => {
      navigate("/");
    },
  });
};
